import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./styles/navbar.css";
import logo from "../images/logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close the menu when a link is clicked
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo-container">
        <div className="logo-bg">
          <img src={logo} alt="Cupcake Logo" className="logo" />
        </div>
        <div className="text-container">
          <h1 className="title">New Ganesh Bakers</h1>
          <p className="subtitle">Taste, Tradition, Trust Since 1989</p>
        </div>
      </div>

      <nav className="nav">
        <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <li>
            <NavLink
              to="/"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about_us"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              About Us
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/our_products"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Our Products
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/menu"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Menu
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/outlets"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Outlets
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Gallery
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact_us"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Contact Us
            </NavLink>
          </li>
        </ul>

        {/* Hamburger Menu */}
        <div className="hamburger" onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
